/**
 * Converts an HTML string to plain text.
 * @param html The HTML string to convert.
 * @returns The plain text representation of the HTML string.
 * @story User Story 8289: Action Card Recommendations: Text-to-Speech action
 */
export function htmlToPlainText(html: string) {
  // Create a new div element
  const tempDiv = document.createElement('div')
  // Set the HTML content with the provided HTML string
  tempDiv.innerHTML = html
  // Use the textContent property to get the plain text
  const text = tempDiv.textContent || tempDiv.innerText || ''
  // Remove extra whitespace and newlines
  return text.replace(/\s+/g, ' ').trim()
}
